import {TransactionId} from '@raison/types';
import * as Schema from 'effect/Schema';
import {To} from 'history';
import {NavigateOptions, useLocation, useNavigate, useParams} from 'react-router';

const decodeTransactionIdParams = Schema.decodeUnknownSync(
    Schema.Struct({
        transactionId: Schema.NumberFromString.pipe(Schema.optional),
    })
);

export const useTransactionIdParam = () => {
    const params = useParams();
    const {transactionId} = decodeTransactionIdParams(params);
    return transactionId as TransactionId;
};

export const createTransactionIdPath = (transactionId?: TransactionId, search = ''): To => {
    if (transactionId) {
        return {pathname: `/transactions/${transactionId}`, search};
    } else {
        return {pathname: `/transactions`, search};
    }
};

export function executeOperationFinishNavigation(
    transactionId: TransactionId,
    navigate: (to: To, options?: NavigateOptions) => void,
    options?: {replace?: boolean; search?: string}
) {
    navigate(createTransactionIdPath(), {replace: options?.replace});
    queueMicrotask(() => navigate(createTransactionIdPath(transactionId, options?.search)));
}

export const useShowTransactionDetails = () => {
    const navigate = useNavigate();
    const {search} = useLocation();
    return (id: TransactionId) => {
        executeOperationFinishNavigation(id, navigate, {search});
    };
};
